/**
 * @Author: Li, Yu Jia
 * @Date: 2020-07-27 11:10:24
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-08-01 09:07:58
 */
export const loadParameters = () => {
  try {
    const serializedState = sessionStorage.getItem('apl_state_parameters');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (_) {
    return undefined;
  }
};

export const saveParameters = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('apl_state_parameters', serializedState);
  } catch (_) {}
};
